// extracted by mini-css-extract-plugin
export var brand = "_99-9";
export var compact = "_99-6";
export var extraSmall = "_99-7";
export var icon = "_99-0";
export var large = "_99-4";
export var light = "_99-1";
export var medium = "_99-5";
export var outline = "_99-b";
export var primaryDark = "_99-a";
export var primaryLight = "_99-8";
export var primaryModern = "_99-c";
export var success = "_99-2";
export var successSolid = "_99-3";